module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "main-nav flex align-center justify-center"
  }, [_c('ul', {
    staticClass: "clean-list flex align-center"
  }, [_c('router-link', {
    staticClass: "active",
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Appsus")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "active",
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("About")])])], 1)]), _vm._v(" "), _c('AppBar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "logo flex align-center justify-center"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png"),
      "alt": "Company name"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer flex justify-center align-center clean-list"
  }, [_c('li', [_vm._v("© 2017 Coding Academy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cda44b36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 295
// module chunks = 1